import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';

@Pipe({name: 'dateShort'})
export class DateShortPipe implements PipeTransform {

    constructor(
        private translate: TranslateService
    ) {
    }

    transform(date: Date | string | number): string {
        return new DatePipe(this.translate.currentLang).transform(date, 'fullDate') ?? '';
    }
}

@Pipe({name: 'dateWeekdayShort'})
export class DateWeekdayShortPipe implements PipeTransform {

    constructor(
        private translate: TranslateService
    ) {
    }

    transform(date: Date | string | number): string {
        const datePipe = new DatePipe(this.translate.currentLang);
        const fullDate = datePipe.transform(date, 'fullDate') ?? '';
        const weekday = (datePipe.transform(date, 'EEE') ?? '').replace('.', '').toUpperCase();

        return fullDate.replace(/^[^,]+/, weekday);
    }
}

@Pipe({name: 'timeShort'})
export class TimeShortPipe implements PipeTransform {

    constructor(
        private translate: TranslateService
    ) {
    }

    transform(date: Date | string | number): string {
        return new DatePipe(this.translate.currentLang).transform(date, 'HH:mm') ?? '';
    }
}

@Pipe({name: 'day'})
export class DayPipe implements PipeTransform {

    constructor(
        private translate: TranslateService
    ) {
    }

    transform(date: Date | string): string {
        return new DatePipe(this.translate.currentLang).transform(date, 'longDate') ?? '';
    }
}

@Pipe({name: 'monthYear'})
export class MonthYearPipe implements PipeTransform {

    constructor(
        private translate: TranslateService
    ) {
    }

    transform(date: Date | string, format = 'MMMM yyyy'): string {
        return new DatePipe(this.translate.currentLang)
            .transform(date, format) ?? '';
    }
}

@Pipe({name: 'weekday'})
export class WeekdayPipe implements PipeTransform {

    constructor(
        private translate: TranslateService
    ) {
    }

    transform(date: Date | string): string {
        return new DatePipe(this.translate.currentLang)
            .transform(new Date(date), 'd') ?? '';
    }

}
